import React from "react";

/**
 * Global ErrorBoundary — catches any React/JS error in the tree and shows a
 * friendly Arabic recovery card instead of a blank white screen. Auto-logs
 * the error and gives the user 3 actions:
 *   1. Reload
 *   2. Clear cache & reload (fixes stale SW issues)
 *   3. Report via WhatsApp
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }

  componentDidCatch(err, info) {
    try { console.error("Talabya crash:", err, info); } catch { /* noop */ }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = String(this.state.err?.message || this.state.err || "");
    const hardReload = async () => {
      try {
        if ("caches" in window) {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
        if ("serviceWorker" in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations();
          await Promise.all(regs.map((r) => r.unregister()));
        }
      } catch { /* noop */ }
      window.location.replace("/");
    };
    const wa = "https://wa.me/218911111111?text=" + encodeURIComponent("مشكلة في تطبيق طلبية: " + msg.slice(0, 200));
    return (
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"Tajawal,Cairo,system-ui,sans-serif",background:"#FAF8F5",padding:24,textAlign:"center"}}>
        <div style={{maxWidth:440,background:"#fff",borderRadius:24,boxShadow:"0 8px 24px rgba(0,0,0,0.08)",padding:"28px 22px"}}>
          <div style={{fontSize:44,marginBottom:12}}>⚠️</div>
          <h1 style={{fontFamily:"Cairo,sans-serif",fontWeight:900,fontSize:20,margin:"0 0 8px",color:"#B91C1C"}}>حدث خطأ غير متوقع</h1>
          <p style={{fontSize:14,lineHeight:1.7,color:"#333",margin:"0 0 18px"}}>
            نعتذر — واجه التطبيق مشكلة. جرّب الأزرار أدناه:
          </p>
          <div style={{display:"grid",gap:8}}>
            <button onClick={() => window.location.reload()}
              style={{padding:"12px 20px",borderRadius:12,background:"#2547D0",color:"#fff",fontWeight:700,fontSize:14,border:"none",cursor:"pointer"}}>
              🔄 إعادة تحميل
            </button>
            <button onClick={hardReload}
              style={{padding:"12px 20px",borderRadius:12,background:"#059669",color:"#fff",fontWeight:700,fontSize:14,border:"none",cursor:"pointer"}}>
              🧹 مسح الذاكرة وإعادة التحميل
            </button>
            <a href={wa} target="_blank" rel="noopener noreferrer"
              style={{padding:"12px 20px",borderRadius:12,background:"#25D366",color:"#fff",fontWeight:700,fontSize:14,textDecoration:"none",display:"block"}}>
              💬 راسل الدعم عبر واتساب
            </a>
          </div>
          {msg && <details style={{marginTop:14,textAlign:"right",fontSize:11,color:"#777"}}>
            <summary style={{cursor:"pointer"}}>تفاصيل تقنية</summary>
            <pre style={{whiteSpace:"pre-wrap",wordBreak:"break-word",background:"#f5f5f5",padding:8,borderRadius:6,marginTop:6}}>{msg}</pre>
          </details>}
        </div>
      </div>
    );
  }
}
